import z from "zod";

const remiPackageValues = [
  "ABLY",
  "ANTHROPIC",
  "AUDIO_PROCESSING",
  "BASE",
  "CLASSIFY",
  "COMPANY_CAM",
  "CONTEXT",
  "DATA_SYNC",
  "DB",
  "DI_PATTERN",
  "ENVIRONMENT",
  "EQHO",
  "FINANCE",
  "FORMATTING",
  "GITHUB",
  "GMAIL",
  "GOODLEAP",
  "GOOGLE_AI",
  "GOOGLE_CALENDAR",
  "GOOGLE_SHEETS",
  "GOOGLE_TRANSLATE",
  "GROOVE",
  "GUT_CHECK",
  "HOVER",
  "HUBSPOT",
  "INSPECTIFY",
  "KNOCK",
  "LANGCHAIN",
  "LENSING",
  "LINEAR",
  "LOCALIZATION",
  "LOGGING",
  "MATERIALS",
  "MCP",
  "MONITORS",
  "NEARMAP",
  "NOTIFICATIONS",
  "OPENAI",
  "AGENT_ACTIONS",
  "OPEN_PHONE",
  "DROPBOX_SIGN",
  "PANDADOC",
  "PAY_KEEPER",
  "PERMISSIONS",
  "PHASES",
  "PLANETSCALE",
  "PROPERTY_MODEL",
  "PUPPETEER",
  "QUICKBOOKS",
  "QUOTING",
  "REDIS",
  "S3",
  "SECRETS_MANAGER",
  "SECURITY",
  "SENTRY",
  "SLACK",
  "SMARTY",
  "SMS",
  "SQS",
  "SUNLIGHT",
  "SUNRUN",
  "SUNRUN_API",
  "SUNRUN_AUTOMATION",
  "SVIX",
  "TWILIO",
  "TYPESAFE",
  "UPSTASH",
  "UTILS",
  "VAL3DITY",
  "MEASUREMENT_REPORT",
  "WORKFLOW",
  "XACTANALYSIS",
  "SYMBILITY",
  "OPENLY",
  "TINYBIRD",
  "THREE_D_MODEL_DATA_PROCESSING",
] as const;

const remiPackageSchema = z.enum(remiPackageValues);
export const RemiPackage = remiPackageSchema.enum;
export type RemiPackage = z.infer<typeof remiPackageSchema>;
